import Divider from '@zenbusiness/zui/Divider';
import Menu from '@zenbusiness/zui/Menu';
import { styled } from '@zenbusiness/zui/styles';

const MenuStyle = ({ theme }) => ({
  '& .MuiPaper-root': {
    maxHeight: 'fit-content',
    padding: '8px 0',
    border: `1px solid ${theme.palette.border.main}`,
    boxShadow: '0px 4px 16px 2px rgba(0, 0, 0, 0.12)',
    borderRadius: '16px'
  }
});

const DividerStyle = () => ({
  marginTop: '8px !important',
  marginBottom: '8px !important'
});

export const MenuStyled = styled(Menu)(MenuStyle);
export const DividerStyled = styled(Divider)(DividerStyle);
